import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import tooltipFactory from 'react-toolbox/lib/tooltip/Tooltip';
import tooltipTheme from './Tooltip.scss';
import classnames from 'classnames';
import { Portal } from 'react-portal';

const Tooltip = tooltipFactory({});
/**
 * @deprecated Use @component Popover with hover as trigger option since this will be moved to Popover soon
 *
 */
const themedTooltipFactory = WrappedComponent => {
    const TooltippedComponent = Tooltip(WrappedComponent);
    const MouseTooltippedComponent = MouseTooltip(WrappedComponent);
    class TooltipComponent extends Component {
        render() {
            const {
                invert,
                smallTooltip,
                activateTooltipOn,
                theme,
                tooltipClassName,
                tooltipHideOnHover,
                ...others
            } = this.props;
            const tooltipClass = classnames(tooltipClassName, {
                [theme.invert]: invert,
                [theme.smallTooltip]: smallTooltip,
                [theme.tooltipHideOnHover]: tooltipHideOnHover
            });
            return activateTooltipOn === 'mouse' ? (
                <MouseTooltippedComponent
                    theme={theme}
                    tooltipClassName={tooltipClass}
                    {...others}
                />
            ) : (
                <TooltippedComponent
                    theme={theme}
                    tooltipClassName={tooltipClass}
                    tooltipHideOnHover={tooltipHideOnHover}
                    {...others}
                />
            );
        }
    }
    return themr('TooltipComponent', tooltipTheme)(TooltipComponent);
};

const MouseTooltip = ComposedComponent => {
    class TooltipMouseComponent extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                visible: false,
                style: {}
            };
        }
        handleMouseEnter = e => {
            this.setState({
                visible: true,
                top: e.clientY + 25,
                left: e.clientX
            });
        };
        handleMouseMove = e => {
            this.setState({
                visible: true,
                top: e.clientY + 25,
                left: e.clientX
            });
        };
        handleMouseLeave = () => {
            this.setState({ visible: false, top: null, left: null });
        };

        render() {
            const {
                className,
                children,
                theme,
                tooltipDelay, //eslint-disable-line no-unused-vars
                tooltipHideOnClick, //eslint-disable-line no-unused-vars
                tooltipPosition, //eslint-disable-line no-unused-vars
                tooltipClassName,
                tooltip,
                ...others
            } = this.props;
            const { top, left, visible } = this.state;
            const positionClass = tooltipPosition
                ? `tooltip${
                      tooltipPosition.charAt(0).toUpperCase() +
                      tooltipPosition.slice(1)
                  }`
                : null;
            const _className = classnames(
                theme.tooltip,
                theme.mouseTooltip,
                tooltipClassName,
                {
                    [theme.tooltipActive]: visible,
                    [theme[positionClass]]: positionClass
                }
            );
            return (
                <ComposedComponent
                    {...others}
                    className={className}
                    onMouseMove={this.handleMouseMove}
                    onMouseLeave={this.handleMouseLeave}
                    onMouseEnter={this.handleMouseEnter}
                    theme={theme}
                >
                    {children ? children : null}
                    {visible ? (
                        <Portal>
                            {tooltip !== null ? (
                                <span
                                    className={_className}
                                    data-react-toolbox="tooltip"
                                    style={{ top, left }}
                                >
                                    <span className={theme.tooltipInner}>
                                        {tooltip}
                                    </span>
                                </span>
                            ) : null}
                        </Portal>
                    ) : null}
                </ComposedComponent>
            );
        }
    }
    return TooltipMouseComponent;
};

export default themedTooltipFactory;
export { themedTooltipFactory as Tooltip };
